export const buildInitials = (firstName, lastName) => {
  const firstInitial = firstName?.[0] || '';
  const lastInitial = lastName?.[0] || '';
  return firstInitial + lastInitial;
};
